import React from 'react';

function TeslimatPage() {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-4xl mx-auto prose">
      <h1 className="text-3xl font-bold text-brand-green mb-4">Teslimat Bilgileri</h1>
      
      <h2>Kargo Süreci</h2>
      <p>Siparişleriniz, anlaşmalı kargo şirketimiz aracılığıyla adresinize teslim edilmektedir. Hafta içi saat 15:00'e kadar verilen siparişler aynı gün kargoya verilir.</p>

      <h2>Teslimat Süresi</h2>
      <p>Kargoya verilen siparişleriniz, teslimat adresinize bağlı olarak genellikle 1-3 iş günü içinde ulaşmaktadır. Kargo takip numaranız, siparişiniz kargoya verildiğinde e-posta adresinize gönderilecektir.</p>
    </div>
  );
}

export default TeslimatPage;